import type { Security } from '@ipfabric/utils';

/**
 * Whether a policy box would tell the reader something the chain itself does
 * not. It would not when the chain *is* one policy's chain — a GCP level, whose
 * heading already names it — so a box there only repeats the heading and buries
 * every rule a level deeper. An enforcement point's entry chain always gets
 * boxes: it merges policies, and its own name (`NIC security (inbound)`) names
 * none of them, not even when only one is attached.
 *
 * Counted over the whole chain, not the page: a page that happens to hold a
 * single policy's rules still needs its box when the chain has several.
 */
export const chainNeedsPolicyBoxes = (
  chain: Security.RuleChain | null,
): boolean => {
  if (chain === null || chain.isEntryChain) {
    return true;
  }
  const policies = new Set(
    chain.rules.flatMap((rule) =>
      rule.cloudPolicy === undefined ? [] : [rule.cloudPolicy.id],
    ),
  );
  return policies.size > 1;
};
